import { Utils } from '@common';
import { ModelContainerWidget } from '@component';
import { FlexAlignment, FlexContainerProps, GridContainerProps } from '@my-types';

/**
 * 移动端容器, 使用Grid布局.
 * 提供了网格布局的初始计算方法
 */
abstract class GridContainer<
	P extends GridContainerProps,
	S,
	C
> extends ModelContainerWidget<P, S, C> {
	protected getGridTemplates(): string | undefined {
		return this.props.gridTemplates;
	}
	protected getGridColumns(): number | undefined {
		return this.props.gridColumns;
	}
	protected buildGridTemplateAreas(): string {
		const templates = this.getGridTemplates();
		if (templates) {
			// 定义过模板, 优先生效
			return templates;
		} else {
			// 否则使用列均分布局
			return Utils.times('1fr', this.getGridColumns()).join(' ');
		}
	}
}

/**
 * 移动端容器, 使用Flex布局.
 */
abstract class FlexContainer<
	P extends FlexContainerProps,
	S,
	C
> extends ModelContainerWidget<P, S, C> {
	protected getAlignment(): FlexAlignment {
		return this.props.align
			? (this.props.align as FlexAlignment)
			: FlexAlignment.START;
	}
	protected buildAlignment(): string {
		const align = this.getAlignment();
		switch (align) {
			case FlexAlignment.START:
			case FlexAlignment.END:
				return `flex-${align}`;
			case FlexAlignment.AOURND:
			case FlexAlignment.BETWEEN:
			case FlexAlignment.EVENLY:
				return `space-${align}`;
			default:
				return align;
		}
	}
}

export { GridContainer, FlexContainer };

